<template>
  <div class="accrual-number">
    {{ fullName }}
  </div>
</template>
<script>
import { defineComponent } from 'vue'
import userApi from '@/api/users'

export default defineComponent({
  name: 'AccrualNumber',
  props: {
    userId: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    fullName: '',
  }),
  async mounted () {
    await Promise.allSettled([
      this.fetchUser(userApi.getTeacher),
      this.fetchUser(userApi.getLogopedist)
    ])
  },
  methods: {
    async fetchUser (apiMethod) {
      try {
        const { data: response, } = await apiMethod({
          filter: {
            id: this.userId,
          },
        })

        if (response?.success) {
          const userInfo = response?.result?.rows[0].attributes
          this.fullName = `${userInfo.lastName} ${userInfo.firstName} ${userInfo.middleName}`
        }
      } catch (error) {
        console.warn(error)
      }
    },
  }
})
</script>

<style scoped lang="scss">
@import '@/assets/styles/colors.scss';
@import '@/widgets/accruals-table/styles/typography.scss';

.accrual-number {
  color: $dark-400;
  @include base-text;
}
</style>
